import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import CustomRadio from '../../../../../components/customRadio/CustomRadio';
import EmptyPlaceholder from '../../../../../components/emptyPlaceholder/EmptyPlaceholder';
import { EPackageType } from '../../../../../interfaces/packageType';
import { ISuccessState } from '../../../../../interfaces/successState';
import { IUsageData } from '../../../../../interfaces/usageData';
import { getDailyUsage } from '../../../../../services/dashboard';
import { bytesToGb } from '../../../../../util/bytesToGb';
import styles from './NoneBroadbandUsage.module.scss';
import { IDailyUsage } from '../../../../../interfaces/IDailyUsage';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../../store/configureStore';

const weeksList = [
  {
    label: 'Week 1',
    index: 0,
  },
  {
    label: 'Week 2',
    index: 1,
  },
  {
    label: 'Week 3',
    index: 2,
  },
  {
    label: 'Week 4',
    index: 3,
  },
  {
    label: 'Week 5',
    index: 4,
  },
];

interface IProps {
  selectedCircuitId?: string;
  selectedPackageType: EPackageType;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setIsSuccess: React.Dispatch<React.SetStateAction<ISuccessState | undefined>>;
}

const NoneBroadbandUsage = (props: IProps) => {
  const { selectedPackageType, selectedCircuitId, setLoading, setIsSuccess } =
    props;
  const [selectedWeekRadioIndex, setSelectedWeekRadioIndex] = useState(0);
  const [usageData, setUsageData] = useState<IDailyUsage>();

  const { monthIndex } = useSelector(({ usageSummaryPage }: IRootState) => ({
    monthIndex: usageSummaryPage.selectedDailyUsageMonth,
  }));

  useEffect(() => {
    setSelectedWeekRadioIndex(0);
    if (selectedCircuitId) {
      setLoading(true);
      getDailyUsage(selectedCircuitId , monthIndex)
        .then((data: IDailyUsage) => {
          if (data.dailyList.length <= 0) {
            throw new Error('No daily usage data.');
          }
          setUsageData(data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          setIsSuccess({
            isSuccess: false,
            message: error.message,
          });
        });
    }
  }, [selectedCircuitId, selectedPackageType, setLoading, setIsSuccess]);

  return (
    <Row className='justify-content-center'>
      <Col className='col-md-10'>
        {selectedCircuitId &&
          usageData &&
          usageData?.dailyList?.length > 0 && (
            <>
              <CustomRadio
                selectedIndex={selectedWeekRadioIndex}
                onChange={(index: number) => setSelectedWeekRadioIndex(index)}
                items={weeksList.slice(
                  0,
                  Math.ceil(usageData.dailyList.length / 7)
                )}
              />
              <Row
                className={[
                  styles.contentRow,
                  styles.header,
                  'align-items-center mt-3',
                ].join(' ')}
              >
                <Col>Date</Col>
                <Col className='col-auto'>Total(GB)</Col>
              </Row>
              {usageData.dailyList
                ?.slice(
                  selectedWeekRadioIndex * 7,
                  (selectedWeekRadioIndex + 1) * 7
                )
                .map((usage, index) => (
                  <Row
                    key={index}
                    className={[
                      styles.contentRow,
                      styles.row,
                      'align-items-center mt-3',
                    ].join(' ')}
                  >
                    <Col>{usage.date}</Col>
                    <Col className='col-auto'>
                      {usage.totalUsage}
                    </Col>
                  </Row>
                ))}
            </>
          )}

        {(!selectedCircuitId ||
          !usageData ||
          usageData?.dailyList?.length === 0) && (
          <EmptyPlaceholder className='mt-5' />
        )}
      </Col>
    </Row>
  );
};

export default NoneBroadbandUsage;
